import jd_it_consulting from "../images/references/jd_it_consulting_logo.webp";
import kroll_bauausführungen from "../images/references/kroll_bauausführungen_logo.webp";
import momentum_media from "../images/references/momentum_media_logo.webp";

export const references = [
  {
    href: "https://jd-it-consulting.de",
    Image: jd_it_consulting,
    title: "IT-Beratung",
    text: "Webseiten Relaunch",
    linkTitle:
      "Verlinkung zur von WebWerk am Meer erstellten Webseite von JD IT Consulting",
    alt: "Logo des Kieler WebWerk am Meer Kunden JD IT Consulting",
    audio: "jd_it_consulting_testimonial.mp3",
  },
  {
    href: "https://kroll-bau.com",
    Image: kroll_bauausführungen,
    title: "Bauunternehmen",
    text: "Webseiten Erstellung",
    linkTitle:
      "Verlinkung zur von WebWerk am Meer erstellten Webseite von Kroll Bauausführungen",
    alt: "Logo des Kieler WebWerk am Meer Kunden Kroll Bauausführungen",
    audio: "kroll_bauausfuehrungen_testimonial.mp3",
  },
  {
    href: "https://mom-media.de",
    Image: momentum_media,
    title: "OOH-Marketing",
    text: "Webseiten Erstellung",
    linkTitle:
      "Verlinkung zur von WebWerk am Meer erstellten Webseite von Momentum Media GmbH",
    alt: "Logo des Kieler WebWerk am Meer Kunden Momentum Media",
    audio: "momentum_media_testimonial.mp3",
  },
];
